var CookiesPopup = /** @class */ (function () {
    function CookiesPopup(cookieBox, cookieKey, visibilityClass, transitionClass, initCookieCallback, refuseCookieCallback) {
        if (visibilityClass === void 0) { visibilityClass = 'hidden'; }
        if (transitionClass === void 0) { transitionClass = 'disabled'; }
        if (initCookieCallback === void 0) { initCookieCallback = CookiesPopup.defaultInitCookie; }
        if (refuseCookieCallback === void 0) { refuseCookieCallback = CookiesPopup.refuseCookieCallback; }
        this.boxElem = cookieBox.boxElem;
        this.boxActionAccept = cookieBox.boxActionAccept;
        this.boxActionRefuse = cookieBox.boxActionRefuse;
        this.cookieKey = cookieKey;
        this.cookieValue = CookiesPopup.getCookie(cookieKey);
        this.initCookieCallback = initCookieCallback;
        this.refuseCookieCallback = refuseCookieCallback;
        this.visibilityClass = visibilityClass;
        this.transitionClass = transitionClass;
    }
    CookiesPopup.setCookie = function (cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };
    CookiesPopup.getCookie = function (key) {
        var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
        return keyValue ? keyValue[2] : null;
    };
    CookiesPopup.defaultInitCookie = function (cookiesObject) {
        console.log(cookiesObject.cookieValue);
        if (cookiesObject.cookieValue === null) {
            // Cookies not accepted, show the popup
            cookiesObject.boxElem.removeClass(cookiesObject.visibilityClass);
            setTimeout(function () {
                cookiesObject.boxElem.removeClass(cookiesObject.transitionClass);
            }, 100);
        }
        else if (cookiesObject.cookieValue !== null && cookiesObject.cookieValue == 0) {
            CookiesPopup.refuseCookieCallback();
        }
    };
    CookiesPopup.refuseCookieCallback = function () {
        window['ga-disable-UA-120856808-1'] = true;
        console.log(window);
    };
    CookiesPopup.prototype.setRefuseCookieCallback = function (callback) {
        this.refuseCookieCallback = callback;
    };
    CookiesPopup.prototype.init = function () {
        var _this = this;
        this.initCookieCallback(this);
        var value = CookiesPopup.getCookie('megamark_cookies_accepted');
        if (value > 0) { //his go hidden popup cookies
            this.boxElem.addClass('disabled');
            setTimeout(function () {
                _this.boxElem.addClass('hidden');
            }, 300);
        }
        this.boxActionAccept.on('click', function () {
            // If clicked Accept, remember the cookies policy has been accepted
            CookiesPopup.setCookie(_this.cookieKey, 1, 1);
            _this.boxElem.addClass('disabled');
            setTimeout(function () {
                _this.boxElem.addClass('hidden');
            }, 300);
        });
        this.boxActionRefuse.on('click', function () {
            // TODO:Do stuff when refusing
            // If clicked Accept, remember the cookies policy has been accepted
            CookiesPopup.setCookie(_this.cookieKey, 1, 1);
            // this.refuseCookieCallback();
            // CookiesPopup.setCookie(this.cookieKey, 0, 0.2);
            // Event if Accepted hasn't been clicked, hide the popup (it will be shown again next time)
            _this.boxElem.addClass('disabled');
            setTimeout(function () {
                _this.boxElem.addClass('hidden');
            }, 300);
        });
    };
    return CookiesPopup;
}());
